export class JourneyTypesConstant {
  public ONE_WAY: string = 'oneWay';
  public RETURN: string = 'return';
  public MULTI: string = 'multi';
  public Types = [
    {
      value: this.ONE_WAY,
      label: 'SEARCH.JOURNEY_TYPE.ONE_WAY'
    },
    {
      value: this.RETURN,
      label: 'SEARCH.JOURNEY_TYPE.RETURN'
    },
    {
      value: this.MULTI,
      label: 'SEARCH.JOURNEY_TYPE.MULTI'
    }
  ];
}
